import React from 'react';
import { splitByNewLine } from '../utils/file-parsers';
import { useReadTextFileRaw } from 'utils/file-reader';
import { Ufo50ListText } from 'utils/file-reader';

export const Ufo50List = () => {
    const ufo50List = useReadTextFileRaw(Ufo50ListText);

    const lines = splitByNewLine(ufo50List);
    const headerString = lines[0];
    const items = lines.slice(2, lines.length); // remove header

    return (
        <div>
            <h2>{headerString}</h2>
            <>
                {items.map((item, index) => {                    
                    const isGold = item.indexOf("*") > 0;   
                    const isCherry = item.indexOf("**") > 0;                 
                    let completionImage = null;                    
                    if (isGold) completionImage = <img src={require('../source-data/Ufo50_gold.png')} alt="gold" width={12} height={12} />;
                    if (isCherry) completionImage = <img src={require('../source-data/Ufo50_cherry.png')} alt="cherry" width={12} height={12} />;
                    const displayText = item.replaceAll("*", "");
                    return (
                        <>
                            {index+1}. {displayText} {completionImage}
                            <br />
                        </>
                    )                    
                })}                    
            </>
        </div>
    );
};